import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import styled, { keyframes } from 'styled-components/macro'
import IconAngleDown from '../../../assets/img/icon_angle_down.png'

export const sliceDown = keyframes`
  0%{
    max-height: 0;
  }
  100% {
    max-height: 160px;
  }
`

export const DivGnbFix = styled.header`
  background-color: #224fac;
  position: sticky;
  top: 0;
  left: 0;
  width: 100%;
  height: 4rem;
  display: flex;
  align-items: center;
  z-index: 10;
  box-shadow: 0 0.15rem 0.3rem #ccc;
`

export const StyledLi = styled.li`
  position: relative;
  & > div {
    display: none;
  }
  &:hover {
    & > div {
      display: block;
      overflow: hidden;
      animation: ${sliceDown} 1s;
    }
  }
`

export const DivGnbCenter = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 8rem;
  margin: 0 auto;

  @media ${(props) => props.theme.media.xl} {
    padding: 0 2rem;
  }
`
export const DivLogoWrap = styled.div`
  width: 10.5rem;
  height: 100%;
  float: left;
  & > a {
    display: block;
  }
  & > a > img {
    width: 10rem;
    vertical-align: middle;
  }
`
export const BesuWrap = styled.div`
  display: inline-block;
  font-size: 1rem;
  color: #aef3ed;
  margin: 0.4rem 0 0 0;

  @media ${(props) => props.theme.media.xl} {
    display: none;
  }
`

export const UlMainMenu = styled.ul`
  & > li {
    margin-left: -0.2rem;
    width: 8rem;
    display: inline-block;
  }
  & > li > a {
    font-size: 1rem;
    font-weight: 700;
    font-family: 'Montserrat';
    display: block;
    text-align: center;
    transition: all 0.2s;
    color: #fff;
  }
  & > li > a:hover {
    color: #aef3ed;
  }
  & > li > a::after {
  }
  & > li:last-child {
    vertical-align: middle;
  }
  &::after {
    content: '';
    display: block;
    clear: both;
  }

  @media ${(props) => props.theme.media.xl} {
    display: none;
  }
`

export const GnbDownIcon = styled.a`
  cursor: pointer;
  &:after {
    content: url(${IconAngleDown});
    margin-left: 0.25rem;
  }
`

export const DivSuvMenu = styled.div`
  box-shadow: 0 3px 6px #ccc;
  display: none;
  position: absolute;
  z-index: 10;
  background: #fff;
  margin: 0 1rem;
  width: 6rem;

  & > ul > a > li {
    line-height: 2rem;
    padding-left: 0.8rem;
    font-size: 0.6rem;
    font-family: 'Montserrat';
    font-weight: 400;

    width: 6rem;
    cursor: pointer;
  }
  & > ul > a > li:hover {
    font-weight: 400;
    text-align: left;
    background-color: #224fac;
    color: #fff;
    transition: all 0.5s;
  }
`
export const HeaderBarIcon = styled(FontAwesomeIcon)`
  display: none;
  color: #b5c9cc;
  cursor: pointer;
  @media ${(props) => props.theme.media.xl} {
    display: block;
  }
`

export const HeadeBarNav = styled.div<{ isNavOpen: boolean }>`
  width: 100%;
  position: absolute;
  display: none;
  top: 4rem;
  left: 0;
  flex-direction: column;
  background-color: #224fac;

  @media ${(props) => props.theme.media.xl} {
    display: ${(props) => (props.isNavOpen ? 'flex' : 'none')};
  }
`

export const NavUl = styled.ul`
  width: 100%;
  display: flex;
  flex-direction: column;
`

export const NavLi = styled.li`
  width: 100%;
  display: flex;
  line-height: 2.4rem;
  flex-grow: 1;
  flex-shrink: 0;
  justify-content: center;
  font-size: 1rem;
  font-weight: 700;
  font-family: 'Montserrat';
  text-align: center;
  color: #f5f5f5;

  &:hover {
    color: #aef3ed;
  }
`

export const NavLiWithSUbNav = styled(NavLi)`
  display: flex;
  flex-direction: column;
  & > ul {
    height: 0px;
    overflow: hidden;
    transition: height 1s;
  }

  &:hover {
    & > ul {
      height: 108px;
      overflow: hidden;
      transition: height 1s;
    }
  }
`

export const SubNavUl = styled.ul`
  display: none;
  display: flex;
  width: 100%;
  flex-direction: column;
`

export const SubNavLi = styled.li`
  width: 100%;
  color: #f5f5f5;
  line-height: 1.8rem;
  font-size: 0.7rem;
  font-weight: 400;
  &:hover {
    background-color: #003894;
  }
`
